import './Hero.css'

function Hero() {
    return (
        <section className="hero">
            <div className="container">
                <div className="hero-wrap">
                    <div className="hero-text-wrap">
                        <h1
                            style={{
                                transform:
                                    'translate3d(0, 10%, 0) scale3d(1, 1, 1)',
                                opacity: 0.9,
                            }}
                            className="h1 hero-heading"
                        >
                            Build the best web scrapers
                        </h1>
                        <div
                            style={{
                                transform:
                                    'translate3d(0, 10%, 0) scale3d(1, 1, 1)',
                                opacity: 0.9,
                            }}
                            className="body-01 hero-subtext"
                        >
                            Revolutionize your web scraping approach by instantly creating request-based scrapers.
                        </div>
                        <div
                            style={{
                                transform:
                                    'translate3d(0, 10%, 0) scale3d(1, 1, 1)',
                                opacity: 0.9,
                            }}
                            className="hero-btn-wrap"
                        >
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSd7TZFAjsBXEDwsrSZPl5j3-hsNGffCJiwm01jq30J1XVdxSw/viewform?usp=sf_link" target="_blank" className="button-1 w-inline-block">
                                <div className="button-1-text">Sign Up</div>
                            </a>
                            <a href="https://calendly.com/arjun-tryparallel-vf84/30min" target="_blank" className="button-2 w-inline-block w-lightbox">
                                    <div className="button-2-text">Book A Call</div>
                            </a>
                        </div>
                    </div>
                    <div
                        style={{
                            transform:
                                'translate3d(0, 10%, 0) scale3d(1, 1, 1)',
                            opacity: 0.9,
                        }}
                        className="hero-image-box"
                    >
                        <img
                            src=""
                            loading="lazy"
                            sizes="(max-width: 479px) 83vw, (max-width: 767px) 87vw, (max-width: 991px) 88vw, 100vw"
                            alt=""
                            className="hero-image"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;